export const Assets = [
    {
      logo:"/assets/logo/logo.svg",
      logo2:"/assets/logo/privacy-logo.svg",
      logo_16: "/assets/logo/favicon-16x16.svg",
      logo_32: "/assets/logo/favicon-32x32.svg",
      logo_192: "/assets/logo/favicon-192x192.svg",
      logo_270: "/assets/logo/favicon-270x270.svg",
      logo_512: "/assets/logo/favicon-512x512.svg",
      logo_head: "/assets/logo/logo-head.png",
      home: "/assets/logo/home.svg",
      drop_down_icon: "/assets/logo/drop_down.svg",
      // og
      og_image:"/assets/og/bestgamespot.png",
      // Cate
      searchIcon: "/assets/items/search.svg",
      exclusiveIcon: "",
      princessIcon: "",
      dressUpGames: "",
      makeoverGames: "",
      decorationGames: "",
      weddingGames: "",
      celebrityGames: "",
      cookingGames: "",
      doctorGames: "",
      // search
      s_icon: "/assets/logo/search.svg",
      c_icon: "/assets/logo/sclose.svg",
      f_icon: "/assets/items/full-screen.svg",
      mback_icon: "/assets/items/back.svg",
      //new lablel
      new_l: "/assets/items/new3.svg",
      // m_play
      m_play_btn: "/assets/items/play.svg",
      image404:"/assets/logo/404.svg",
      logo_header:"/assets/logo/logo.svg",
      navicon:"/assets/nav/navicon.png",
      nav_S_icon: "/assets/nav/search.svg",
      nav_Clear_icon: "/assets/nav/close.svg",
      halloween: "/assets/trans/halloween.svg",
    }
  ];